export const CTA_URL = "https://ohqak.bemobtrcks.com/click";
